import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  skeletonContainer: {
    flex: 1,
    paddingTop: theme.spacing[8],
  },
});
